import React from 'react';
import styled from 'styled-components';

const SectionWrap = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 14px 0 22px;
`;

const Content = styled.div`
  width: min(1280px, calc(100% - 36px));
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 650px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const TabCard = styled.a`
  background: #fff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
  text-decoration: none;
  color: #2f3640;
  padding: 14px;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.18s ease, box-shadow 0.18s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 26px rgba(15, 23, 42, 0.14);
    color: #2f3640;
  }
`;

const CardImgWrap = styled.div`
  width: 100%;
  height: 120px;
  border-radius: 12px;
  background: #f4f6f8;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const CardImg = styled.img`
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
`;

const CardTitle = styled.h3`
  margin: 10px 0 4px;
  font-size: 1.25rem;
  line-height: 1.2;
  font-weight: 700;
  color: #2f3640;
`;

const CardTag = styled.span`
  display: inline-block;
  margin-top: 2px;
  font-size: 0.92rem;
  color: #5ba7af;
  font-weight: 600;
`;

const CardCopy = styled.div`
  text-align: center;
`;

const Section2 = () => {
  const tabs = [
    {
      title: 'Superstar',
      category: 'Salas de Juego',
      href: 'https://superstar.com.ar',
      image: './img/superstar.png',
    },
    {
      title: 'Videodrome',
      category: 'Salas de Juego',
      href: 'https://casinosmacgroup.bet.ar',
      image: './img/videodrome.png',
    },
    {
      title: 'Casinos',
      category: 'Juego Online',
      href: 'https://casinosmacgroup.bet.ar/',
      image: './img/logo-mac-top.png',
    },
    {
      title: 'BPlay',
      category: 'Juego Online',
      href: 'https://www.bplay.bet.ar/',
      image: './img/biplay.jpg',
    },
  ];

  return (
    <SectionWrap>
      <Content>
        {tabs.map((tab) => (
          <TabCard key={tab.title} href={tab.href} target="_blank" rel="noopener noreferrer">
            <CardImgWrap>
              <CardImg src={tab.image} alt={tab.title} />
            </CardImgWrap>
            <CardCopy>
              <CardTitle>{tab.title}</CardTitle>
              <CardTag>{tab.category}</CardTag>
            </CardCopy>
          </TabCard>
        ))}
      </Content>
    </SectionWrap>
  );
};

export default Section2;
